import { makeVar } from '@apollo/client';

const CACHE_PERSIST_KEY = 'apollo-cache-persist';
const isCachedData = Boolean(localStorage.getItem(CACHE_PERSIST_KEY));
export const cacheState = makeVar(isCachedData);
